import { recordEventCustomOnly } from 'utilities/uTagging';

export const doTagShowTransferIdentificationModal = () => {
    recordEventCustomOnly({
        categoriaEvento: 'onboarding/identidad/',
        accionEvento: 'modal/transferencia-confirmacion',
        etiquetaEvento: 'vista',
    });
};

export const doTagTransferIdentificationModalCancel = () => {
    recordEventCustomOnly({
        categoriaEvento: 'onboarding/identidad/',
        accionEvento: 'modal/transferencia-confirmacion',
        etiquetaEvento: 'volver',
    });
};
export const doTagTransferIdentificationModalContinue = () => {
    recordEventCustomOnly({
        categoriaEvento: 'onboarding/identidad/',
        accionEvento: 'modal/transferencia-confirmacion',
        etiquetaEvento: 'continuar',
    });
};
